
import React from 'react';
import { useTranslation } from 'react-i18next';
import useDreamWeaveData from '../../hooks/useDreamWeaveData';
import LoadingSpinner from '../LoadingSpinner';

const DreamWeaveStats = ({ dreamWeaveId, nexusId }) => {
    const { t } = useTranslation();
    const { neurons, synapses, souls, loading, error } = useDreamWeaveData(dreamWeaveId, nexusId);

    if (loading) {
        return <LoadingSpinner message={t('dreamWeaveStats.loading')} />;
    }

    if (error) {
        return <p className="text-red-500">{t('dreamWeaveStats.error')}</p>;
    }

    return (
        <div className="bg-gray-900/50 backdrop-blur-sm p-4 rounded-lg border border-cyan-500/20">
            <h2 className="text-xl font-bold text-cyan-300 mb-4 text-center">{t('dreamWeaveStats.title')}</h2>
            <div className="grid grid-cols-2 gap-4 text-center">
                <div>
                    <p className="text-2xl font-bold text-purple-300">{neurons.length}</p>
                    <p className="text-sm text-gray-400">{t('dreamWeaveStats.neurons')}</p>
                </div>
                <div>
                    <p className="text-2xl font-bold text-purple-300">{synapses.length}</p>
                    <p className="text-sm text-gray-400">{t('dreamWeaveStats.synapses')}</p>
                </div>
                <div>
                    <p className="text-2xl font-bold text-yellow-400">{souls}</p>
                    <p className="text-sm text-gray-400">{t('dreamWeaveStats.totalSouls')}</p>
                </div>
                <div>
                    <p className="text-2xl font-bold text-green-400">+12/hr</p>
                    <p className="text-sm text-gray-400">{t('dreamWeaveStats.growthRate')}</p>
                </div>
            </div>
        </div>
    );
};

export default DreamWeaveStats;
